const BLOCK_USER = 'BLOCK_USER';
const MUTE_USER = 'MUTE_USER';

export { BLOCK_USER, MUTE_USER };
